export default __webpack_public_path__ + "static/media/redClose.6a1ccbca.svg";